const NOTIFICATION_MODEL_CLASS_NAME = 'Notification'

const NOTIFICATION_MODEL_KEY = {
  NOTIFICATION_MODEL_TYPE: 'type',
  READ: 'read',
  VISITED: 'visited',
  COUNT: 'count',
  USER: 'user',
  ORDERS: 'orders',
  PRODUCTS: 'products',
  COMMENTS: 'comments',
  // Foreign key
  USER_ID: 'userId'
}

const NOTIFICATION_MODEL_KEY_POINTER = NOTIFICATION_MODEL_KEY.ID

const NOTIFICATION_MODEL_TYPE = {
  CART_ADD_PRODUCT: 1,
  ORDER_STATUS_CHANGE: 2,
  COMMENT_REPLY: 3,
  COMMENT_MENTION: 4
}

const NOTIFICATION_MODEL_ASSOCIATION = {
  [NOTIFICATION_MODEL_KEY.COMMENTS]: 'Comment',
  [NOTIFICATION_MODEL_KEY.USER]: 'User',
  [NOTIFICATION_MODEL_KEY.ORDERS]: 'Order',
  [NOTIFICATION_MODEL_KEY.PRODUCTS]: 'Product'
}

export {
  NOTIFICATION_MODEL_CLASS_NAME,
  NOTIFICATION_MODEL_KEY,
  NOTIFICATION_MODEL_KEY_POINTER,
  NOTIFICATION_MODEL_TYPE,
  NOTIFICATION_MODEL_ASSOCIATION
}
